/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareCampaign,
  SterWebsiteModelPriceCompareCampaignFromJSON,
  SterWebsiteModelPriceCompareCampaignFromJSONTyped,
  SterWebsiteModelPriceCompareCampaignToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareCalculateRequest
 */
export interface SterWebsiteModelPriceCompareCalculateRequest {
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareCampaign>}
   * @memberof SterWebsiteModelPriceCompareCalculateRequest
   */
  campaigns?: Array<SterWebsiteModelPriceCompareCampaign>;
  /**
   *
   * @type {Array<string>}
   * @memberof SterWebsiteModelPriceCompareCalculateRequest
   */
  conversionGroups?: Array<string>;
}

export function SterWebsiteModelPriceCompareCalculateRequestFromJSON(
  json: any
): SterWebsiteModelPriceCompareCalculateRequest {
  return SterWebsiteModelPriceCompareCalculateRequestFromJSONTyped(json, false);
}

export function SterWebsiteModelPriceCompareCalculateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareCalculateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    campaigns: !exists(json, "campaigns")
      ? undefined
      : (json["campaigns"] as Array<any>).map(
          SterWebsiteModelPriceCompareCampaignFromJSON
        ),
    conversionGroups: !exists(json, "conversionGroups")
      ? undefined
      : json["conversionGroups"],
  };
}

export function SterWebsiteModelPriceCompareCalculateRequestToJSON(
  value?: SterWebsiteModelPriceCompareCalculateRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    campaigns:
      value.campaigns === undefined
        ? undefined
        : (value.campaigns as Array<any>).map(
            SterWebsiteModelPriceCompareCampaignToJSON
          ),
    conversionGroups: value.conversionGroups,
  };
}
